import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        The AiSCOUT platform leverages the AWS cloud and{' '}
        <a
          href="https://www.intel.com/content/www/us/en/architecture-and-technology/3d-athlete-tracking.html"
          target="_blank"
          rel="noreferrer"
          className="chapter__paragraph__link"
        >
          Intel® 3DAT technology
        </a>{' '}
        to generate objective insights by recognizing, tracking, and analyzing data points from a
        standard smartphone video. Since AiSCOUT has more than 30,000 users all over the world, it
        needed a reliable, secure, and scalable way to store, serve, analyze, and interpret millions
        of data points. The combination of AWS and Intel gives AiSCOUT both speed and global
        accessibility. “One of our philosophies is to give every player in the world the same
        opportunity,” Felton-Thomas says. “For example, we have a client in India that has used our
        product to find players who aren’t even on registered football teams. You could never do
        that unless you have global accessibility. AWS has already built that global infrastructure
        with Intel technology and that was crucial to us.”
      </p>
    </section>
  );
}

export default Chapter5;
